<template>
  <div class="app-extend-wrapper">

    <div class="custom-wrapper op-wrapper"
      v-if="hasRes('store_app_extend_param_add')">
      <el-button
        type="danger"
        size="medium"
        @click="addAppExtendDialogVisible = true">添加应用扩展字段</el-button>
    </div>

    <app-extend-filter
      v-if="hasRes('store_app_extend_param_index')"
      @filter="updateTableData" />

    <custom-table
      :data="appExtendParamList"
      v-if="hasRes('store_app_extend_param_index')"
      @data-change="updateTableData">

      <el-table-column
        prop="extend_param_id"
        label="扩展参数 ID"
        align="center"
        header-align="center">
      </el-table-column>

      <el-table-column
        prop="extend_param_name"
        label="字段名称"
        align="center"
        header-align="center">
      </el-table-column>

      <el-table-column
        prop="app_store_id"
        label="所属应用"
        align="center"
        header-align="center">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              应用 ID: {{ scope.row.app_store_id }} <br/>
              应用分类: {{ getAppCategoryName(scope.row.app_store_id) }}
            </div>
            <span>{{ getAppName(scope.row.app_store_id) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="remarks"
        label="字段解释"
        align="center"
        header-align="center">
      </el-table-column>

      <el-table-column label="操作"
        align="center"
        width="200"
        v-if="hasRes('store_app_extend_param_edit') || hasRes('store_app_extend_param_delete')"
        header-align="center" >
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-if="hasRes('store_app_extend_param_edit')"
            @click="onEditClick(scope.row)">修改</el-button>
          <el-button
            size="mini"
            type="danger"
            v-if="hasRes('store_app_extend_param_delete')"
            @click="onDeleteClick(scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </custom-table>

    <custom-paginate
      :count="appExtendParamCount"
      v-if="hasRes('store_app_extend_param_index')"
      @page-change="updateTableData" />

    <dialog-add-app-extend
      @data-change="updateTableData"
      v-if="hasRes('store_app_extend_param_add')"
      :visible.sync="addAppExtendDialogVisible" />

    <dialog-edit-app-extend
      @data-change="updateTableData"
      :editing-app-extend="editingAppExtend"
      v-if="hasRes('store_app_extend_param_edit')"
      :visible.sync="editAppExtendDialogVisible" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import AppExtendFilter from './components/AppExtendFilter'
import DialogAddAppExtend from './components/DialogAddAppExtend'
import DialogEditAppExtend from './components/DialogEditAppExtend'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING } from '@/store/modules/table'

export default {
  name: 'AppExtend',
  components: {
    CustomTable,
    CustomPaginate,
    AppExtendFilter,
    DialogAddAppExtend,
    DialogEditAppExtend
  },
  data () {
    return {
      addAppExtendDialogVisible: false,

      editAppExtendDialogVisible: false,
      editingAppExtend: {}
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'filters'
    ]),
    ...mapState('store', [
      'appList',
      'appExtendParamList',
      'appExtendParamCount'
    ]),
    ...mapGetters('opUser', [
      'hasResCate',
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING
    ]),
    ...mapActions('store', [
      'getApps',
      'getAppExtendParams',
      'deleteAppExtendParam'
    ]),

    getAppById (appId) {
      for (let i = 0; i < this.appList.length; i++) {
        const app = this.appList[i]
        if (app.app_store_id === appId) {
          return app
        }
      }
      return ''
    },
    getAppName (appId) {
      const app = this.getAppById(appId)
      if (app && app.app_name_i18n.length > 0) {
        return app.app_name_i18n[0].name
      }
      return 'Unknown'
    },
    getAppCategoryName (appId) {
      const app = this.getAppById(appId)
      if (app && app.app_category_detail.app_category_name_i18n.length > 0) {
        return app.app_category_detail.app_category_name_i18n[0].name
      }
      return 'Unknown'
    },

    onEditClick (appExtend) {
      this.editingAppExtend = appExtend
      this.editAppExtendDialogVisible = true
    },
    async onDeleteClick (appExtend) {
      try {
        await this.$confirm(
          '此操作将永久删除扩展字段，是否继续？', '删除扩展字段',
          { confirmButtonText: '确定', cancelButtonText: '取消' }
        )

        await this.deleteAppExtendParam({
          extend_param_id: appExtend.extend_param_id
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
      }
    },

    async updateTableData () {
      if (!this.hasRes('store_app_extend_param_index')) return

      this.setLoading(true)

      try {
        await this.getApps({
          page: 1,
          pageSize: 9999
        })
        await this.getAppExtendParams({
          page: this.page,
          pageSize: this.pageSize,
          condition: this.filters
        })
      } catch (err) {
        console.log(err)
        this.$message({
          tpye: 'error',
          message: '获取应用扩展参数失败'
        })
      }

      this.setLoading(false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/sass/base.scss';
</style>



// WEBPACK FOOTER //
// src/pages/op/store/AppExtend.vue